import React, {useEffect, useRef, useState} from 'react';
import * as Yup from 'yup';
import {registerPlugin} from 'react-filepond';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
import 'filepond/dist/filepond.min.css';
import AsyncCreatableSelect from "react-select/async-creatable";
import {axiosInstance} from "../../../utils/axiosInstance";
import {InputDatePicker} from "jalaali-react-date-picker";
import "jalaali-react-date-picker/lib/styles/index.css";
import DynamicForm from "../../../components/form/dynamicForm";
import {newsTypeOptions} from "../../../services/types/news";
import {DtPicker} from 'react-calendar-datetime-picker'
import 'react-calendar-datetime-picker/dist/style.css'
import {parseIDayToDateStr} from "../../../utils/time";
import {createCategory} from "../../../services/categories";

// Register FilePond plugins
registerPlugin(FilePondPluginFileValidateType, FilePondPluginImagePreview);

const CreateCategories = () => {

        useEffect(() => {
            const loadTagsOptions = async () => {
                const tagsSearchResponse = await axiosInstance.get('tags');
                const tags = tagsSearchResponse.data.results;

                const mappedTagOptions = tags.map((tag) => ({
                    value: tag.id, label: tag.name, createdAt: tag.created_at
                }));

                // Update the tagsOptions with newly fetched options
                setTagsOptions((prevOptions) => {
                    return [...new Map([...prevOptions, ...mappedTagOptions].map(item => [item.value, item])).values()];
                });
            }
            const loadCategories = async () => {
                const tagsSearchResponse = await axiosInstance.get('categories');
                const tags = tagsSearchResponse.data.results;

                const mappedTagOptions = tags.map((tag) => ({
                    value: tag.id, label: tag.name, createdAt: tag.created_at
                }));

                // Update the tagsOptions with newly fetched options
                setCategories((prevOptions) => {
                    return [...new Map([...prevOptions, ...mappedTagOptions].map(item => [item.value, item])).values()];
                });
            }
            try {
                setloading(true)
                loadTagsOptions()
                loadCategories()
            } catch (e) {

            } finally {
                setloading(false)
            }
        }, [])
        // tags
        const [tagsOptions, setTagsOptions] = useState([]);
        const [loading, setloading] = useState(false)

        const [categories, setCategories] = useState([])

        // dynamic form
        const meta = {
            gridColumns: {
                small: 1, medium: 3, large: 4
            },
        };


        const fields = [{
            title: 'عنوان', fieldName: 'name', type: 'string', validation: (value) => Yup.string().max(30).required(),
        }];

        return (!loading && <DynamicForm
            fields={fields}
            meta={meta}
            onSubmit={(values) => {
                console.log('Form values:', values);
                createCategory(values)
            }}
        />);
    }
;

export default CreateCategories;